import { motion } from 'motion/react';
import { 
  ArrowDownTrayIcon, 
  ComputerDesktopIcon,
  ShieldCheckIcon
} from '@heroicons/react/24/outline';

const features = [
  {
    icon: ComputerDesktopIcon,
    title: 'Multi-plateforme',
    description: 'Compatible Windows, macOS (A venir) et Linux (A venir)',
  },
  {
    icon: ShieldCheckIcon,
    title: 'Sécurisé',
    description: 'Vos fichiers MP3 restent sur votre ordinateur. Seule la vérification de licence contacte nos serveurs.'
  }
];

export default function Download() {
  const handleDownload = () => {
    window.open('/downloads/mp3-random-selector_1.0.5_x64_fr-FR.msi', '_blank');
  };

  const handleDownloadPortable = () => {
    window.open('/downloads/mp3-random-selector_1.0.5_fr-en_portable.zip', '_blank');
  };

  return (
    <section id="download" className="py-20 bg-gray-900/30">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ y: 50, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="text-primary-300">Télécharger MP3 Random Selector</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Installez en 2 minutes et commencez à remplir votre prochaine clé USB avec exactement les morceaux que vous voulez.
          </p>
        </motion.div>
        
        <div className="max-w-4xl mx-auto">
          
          {/* Bouton de téléchargement principal */}
          <motion.div
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
            className="mb-12"
          >
            <div className="flex flex-col md:flex-row justify-center gap-4">
              <button
                onClick={handleDownload}
                className="btn-primary text-xl px-12 py-4 mb-2 md:mb-0 group flex items-center justify-center"
                title="Installer l'application sur votre ordinateur (recommandé)"
              >
                <ArrowDownTrayIcon className="w-6 h-6 mr-2 group-hover:animate-bounce" />
                Télécharger (MSI installateur)
              </button>
              <div className="flex flex-col items-center">
                <button
                  onClick={handleDownloadPortable}
                  className="btn-secondary text-xl px-8 py-4 group flex items-center justify-center transition"
                  title="Version portable sans installation, à extraire et lancer directement"
                >
                  <ArrowDownTrayIcon className="w-6 h-6 mr-2 group-hover:animate-bounce" />
                  Version portable (ZIP)
                </button>
              </div>
            </div>
            <p className="text-sm text-gray-500 dark:text-gray-400 text-center mt-2">
              <strong>MSI :</strong> Installation classique avec raccourci menu démarrer. <br />
              <strong>Portable :</strong> Utilisation immédiate, aucune modification système.
              <br />
               <strong>Langues :</strong> Français, Anglais.
              <br />
              Version 1.0.5 • Windows 10/11 • 5 MB (MSI) / 5 MB (Portable ZIP) • Release date : 14/10/2026
            </p>
          </motion.div>
          
          {/* Fonctionnalités du téléchargement */}
          <motion.div
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            viewport={{ once: true }}
            className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12"
          >
            {features.map((feature, index) => (
              <div key={index} className="card text-center">
                <div className="w-12 h-12 bg-gradient-to-r from-primary-500 to-accent-500 rounded-lg flex items-center justify-center mx-auto mb-4">
                  <feature.icon className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                  {feature.title}
                </h3>
                <p className="text-gray-600 dark:text-gray-400 text-sm">
                  {feature.description}
                </p>
              </div>
            ))}
          </motion.div>
          
          {/* Configuration système requise */}
          <motion.div
            initial={{ y: 30, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.8 }}
            viewport={{ once: true }}
            className="card"
          >
            <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-6 text-center">
              Configuration système requise
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <ul className="space-y-2 text-white dark:text-white">
                  <li>• Windows 10/11 (64-bit)</li>
                  <li>• 500 MB RAM</li>
                  <li>• 11 MB d'espace disque</li>
                  <li>• SSD pour de meilleures performances</li>
                </ul>
              </div>
            </div>
          </motion.div>
          
        </div>
      </div>
    </section>
  );
}
